<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div class="searchStyle">
                <!--                <el-input placeholder="请输入内容" v-model="condition" clearable>
                </el-input>
                <el-button type="primary" plain>查询</el-button> -->
              </div>
            </el-row>
            <el-row>
              <el-tooltip class="item" effect="dark" content="" placement="top">
                <el-button type="primary" round @click="addGoods">添加商品</el-button>
              </el-tooltip>

            </el-row>
          </div>
        </div>

        <div style="padding: 10px;">
          <el-table border :data="tableData" stripe style="width: 100%;" :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" >
            </el-table-column>
            <el-table-column prop="category" label="分类" width="200">
            </el-table-column>
            <el-table-column prop="price" label="价格(分)" width="80">
            </el-table-column>
<!--            <el-table-column prop="grade" label="销量" width="80">
            </el-table-column> -->
           <el-table-column label="操作" header-align="center" align="center"  width="150" >
              <template slot-scope="scope">
                <div >
                  <el-button @click.native.prevent="editGoods(scope.$index, tableData)" type="text" size="small">
                    修改商品
                  </el-button>
                  <el-button @click.native.prevent="delGoods(scope.$index, tableData)" type="text" size="small">
                    删除商品
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="delGoodsRecord">删 除</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedID: '',
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        showScoreAvg: false,
        showSection: false,
        showAvgTrend: false,
        unlockDialogVisible: false,
        unlockForm: {
          student_name: '',
          student_num: ''
        },

        img_url: ''

      }
    },
    mounted() {
      // this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session

      console.log('shownotify=' + this.shownotify)

      // this.loadDateList()
      this.loadData()
    },
    methods: {

      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/store/web/_load_goods_list.jsp'
        this.axios.get(requestUrl, {
            params: {
            }
          }).then(function(response) {
            that.tableData = response.data.goods
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      indexMethod() {
        this.index++
        return this.index
      },
      delGoods(index, rows) {
        this.position = index
        this.selectedID = rows[index].id

        this.msg = '确定要删除"' + rows[index].goods_name + '"吗?'

        this.dialogVisible = true
      },
      delGoodsRecord() {
        let that = this
        this.dialogVisible = false

        // 调用删除接口
        var requestUrl = '/score/store/web/_delete_goods.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedID
            }
          }).then(function(response) {
            that.tableData.splice(that.position, 1)
            // that.loadDateList()

            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      editGoods(index, rows) {
        this.position = index
        this.selectedID = rows[index].id
        let that = this

        this.$router.push({
          name: 'goods_edit',
          params: {
            id: that.selectedID
          }
        })
      },
      addGoods() {
        this.$router.push('/goods_edit')
      }

    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/goods_list.vue